import makeStyles from "@mui/styles/makeStyles";

export const usePromotionsStyles = makeStyles((theme) => ({
    title: {
        display: "block"
    },
    paper: {
        padding: 2
    },
    root: {
        padding: theme.spacing(3, 2),
        [theme.breakpoints.down("md")]: {
            padding: theme.spacing(0, 0)
        }
    },
    paperTable: {
        padding: theme.spacing(3, 2),
        [theme.breakpoints.down("sm")]: {
            marginLeft: "32px"
        }
    },
    fullWidth: {
        width: "100%"
    },
    Tabsheader: {
        boxShadow: "none",
        background: "transparent"
    },
    marginBottom: {
        marginBottom: "20px"
    },
    dateField: {
        border: "1px solid #ccc",
        borderRadius: "4px"
    },
    tabsunderline: {
        borderBottom: "1px solid #ccc",
        [theme.breakpoints.down("md")]: {
            marginBottom: "14px"
        }
    },
    flexDisplay: {
        display: "flex",
        alignItems: "center"
    },
    actionsCellWidth: {
        width: "150px"
    },
    cardScrollContent: {
        maxHeight: "230px",
        minHeight: "230px",
        overflow: "auto",
        marginBottom: "15px"
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff"
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    },
    responsiveStatus: {
        [theme.breakpoints.between(1267, undefined)]: {
            maxWidth: "126px"
        },
        [theme.breakpoints.between(340, undefined)]: {
            maxWidth: "116px"
        }
    },
    responsiveDate: {
        [theme.breakpoints.between(340, undefined)]: {
            maxWidth: "80px"
        }
    },
    underline: {
        [theme.breakpoints.between(1267, undefined)]: {
            fontSize: "13px"
        },
        [theme.breakpoints.down(undefined)]: {
            fontSize: "13px"
        },
        [theme.breakpoints.between(350, undefined)]: {
            fontSize: "12px"
        },
        "&:hover": {
            textDecoration: "underline"
        }
    }
}));
